import i18n from '@/common/i18n';
import CommonError from '@/common/utils/errors/CommonError';

export default class NetworkError extends CommonError {
  body?: any;

  constructor(body: any) {
    super(body?.message || i18n.t('Network error'), 'Network error');
    this.body = body;
  }
}
